import React, { useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";

import { useAuth } from "../../context/AuthContext";

const LoginDialog = ({ open, onClose, onRegister }) => {
  const { login } = useAuth();

  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");

  const [error, setError] = useState("");

  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError("");

    if (!email || !password) {
      setError("Email and password are required.");

      return;
    }

    try {
      setLoading(true);

      const result = await login(email, password);

      if (result.success) {
        setEmail("");

        setPassword("");

        onClose();
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError("Login error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Login</DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: "flex",

            flexDirection: "column",

            gap: 2,

            mt: 1,
          }}
        >
          {error && <Alert severity="error">{error}</Alert>}

          <TextField
            label="Email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <TextField
            label="Palavra Passe"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",

          flexDirection: "column",

          gap: 1,

          px: 3,

          pb: 3,
        }}
      >
        <Button
          fullWidth
          variant="contained"
          disabled={loading}
          onClick={handleLogin}
        >
          {loading ? "Entrar..." : "Entrar"}
        </Button>

        <Typography>
          Não tem uma conta?
          <Button
            onClick={() => {
              onClose();
              onRegister();
            }}
          >
            Registar
          </Button>
        </Typography>
      </DialogActions>
    </Dialog>
  );
};

export default LoginDialog;
